import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import axios from 'axios';


const ClothUseEntry = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [formData, setFormData] = useState({});
    const [clothData, setClothData] = useState([]);
    const { Id } = useParams();
    const dispatch = useDispatch();
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed

    useEffect(() => {
        fetchClothUsedData(Id);
    }, [Id]);


    const fetchClothUsedData = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=clothUsed_cuttingMaster&ctId=${id}`);
            const res = response?.data?.data;
            console.log(res);
            const clothnms = response?.data?.clothNames[0];
            setClothData(res);
            setFormData(clothnms);

        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const handleBmtrChange = (cIndex, bIndex, lIndex, value) => {
        const updatedClothdata = [...clothData];

        const newValue = Number(value) || 0;

        const lump =
            updatedClothdata[cIndex]
                .cloth_data[bIndex]
                .lump_data[lIndex];

        const gmtr = Number(lump.bmtr);

        // clamp value so it cannot exceed gmtr
        const finalUsemtr = newValue > gmtr ? gmtr : newValue;

        lump.usemtr = finalUsemtr;
        lump.balmtr = (gmtr - finalUsemtr).toFixed(2);

        setClothData(updatedClothdata);
    };


    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '2vh', margin: '0' }}>
                    <div style={{ margin: '1%', width: '100%' }} ref={componentRef}>
                        <h3 className='centered-heading'>Cloth Use Entry</h3>
                        <div className="dashed-line"></div>

                        <table>
                            <tbody>
                                <tr>
                                    <td>Main Cloth:</td>
                                    <td>{formData.mclothNm}</td>
                                    <td>Total Used Mtr</td>
                                    <td>{formData.mused}</td>
                                </tr>
                            </tbody>
                        </table>


                        {clothData?.map((item, cIndex) => (
                            item?.cloth_data?.map((val, bIndex) => (
                                <div key={bIndex}>
                                    <h3>Bale Details :</h3>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>Bale</td>
                                                <td>{val.baleNo}</td>
                                                <td>Used Mtr.</td>
                                                <td>{val.gMtr}</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <h5>Lump Details :</h5>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Sr.</th>
                                                <th>Barcode</th>
                                                <th>Color</th>
                                                <th>Loose</th>
                                                <th>Given Mtr.</th>
                                                <th>Used Mtr.</th>
                                                <th>Bal Mtr.</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {val?.lump_data?.map((lump, lIndex) => (
                                                <tr key={lIndex}>
                                                    <td>{lIndex + 1}</td>
                                                    <td>{lump.barcd}</td>
                                                    <td>{lump.color}</td>
                                                    <td>{lump.loose === '1' ? 'Loose' : '-'}</td>
                                                    <td>{lump.bmtr}</td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            name="usemtr"
                                                            value={lump.usemtr}
                                                            onChange={(e) =>
                                                                handleBmtrChange(
                                                                    cIndex,
                                                                    bIndex,
                                                                    lIndex,
                                                                    e.target.value
                                                                )
                                                            }
                                                            style={{ width: '80px' }}
                                                        />
                                                    </td>
                                                    <td>{lump.balmtr}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ))
                        ))}


                    </div>
                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>
                </Paper>
            </Grid>
        </>
    );
};

export default ClothUseEntry;
